<button
  class="atm-shopping-button"
  (click)="addToCart($event)"
  [disabled]="(isAddingToCar$ | async) && (isLogged$ | async)"
>
  <img src="assets/icons/shopping-cart-plus.svg" alt="agregar al carrito" />
</button>
